import styled from "styled-components";
export const ItemMenuStyled = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 40;
  max-width: 1200px;
  padding: 0rem 2rem;
  padding-top: 2rem;
  height: 40px;
  margin: 0 auto;
  position: absolute;
  width: 100%;
  top: 0;
  img {
    width: 40px;
    height: 40px;
  }
`;
